var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            this.plugin.call(GG);
            GG.log('AmountControl plugin loaded.');
        }
        else {
            GG.log('AmountControl plugin needs jQuery.');
        }
    },
    plugin: function () {
        var $ = this.$;
        var app = this;
        var methods = {
            init: function (params) {
                var defaults = {};
                var options = __assign({}, defaults, params);
                if (!options.child || !options.control)
                    throw 'Children/controls not specified';
                return this.each(function () {
                    var $wrapper = $(this), $wrapperid = $wrapper.attr('id'), $entries = $wrapper.find(options.child), $data = $wrapper.data('amountControl');
                    if (!$wrapperid) {
                        $wrapper.attr('id', 'ac' + new Date().getTime() + Math.floor(Math.random() * 100));
                    }
                    if (!$data) {
                        $wrapper.data('amountControl', options).addClass('amountControl');
                        $data = options;
                    }
                    methods.updateAmount.call($wrapper, true);
                    $entries.each(function () {
                        methods.setControl.call($wrapper, this);
                    });
                    $wrapper.data('amountControl', $data);
                });
            },
            setControl: function () {
                var $wrapper = this, $data = $wrapper.data('amountControl'), $entry = arguments[0], $input = $($entry)
                    .find($data.control)
                    .find('input');
                $($entry)
                    .find($data.control)
                    .find('ins')
                    .remove();
                $($entry)
                    .find($data.control)
                    .append('<ins class="plus">+</ins>')
                    .append('<ins class="minus">–</ins>');
                var $ins = $($entry)
                    .find($data.control)
                    .find('ins');
                if ($input.val() === $input.attr('data-min')) {
                    $ins.filter('.minus').addClass('disabled');
                }
                if ($input.val() === $input.attr('data-max')) {
                    $ins.filter('.plus').addClass('disabled');
                }
                if ($input.val() > $input.attr('data-min') && $input.val() < $input.attr('data-max')) {
                    $ins.filter('.minus').removeClass('disabled');
                    $ins.filter('.plus').removeClass('disabled');
                }
                function keyupCallback(e) {
                    if ((e.type === 'keyup' && (e.keyCode !== 38 && e.keyCode !== 40)) ||
                        (e.type === 'keydown' && (e.keyCode === 38 || e.keyCode === 40))) {
                        var $entry_1 = $(this).closest($data.child), amount = parseInt($(this).val()) || 0, newamount_1 = 0;
                        if (parseInt(amount) < 0) {
                            amount = amount + '';
                            amount ? (newamount_1 = amount.replace(/\D/g, '')) : 0;
                            newamount_1 = parseInt('-' + newamount_1);
                        }
                        else {
                            amount = amount + '';
                            amount ? (newamount_1 = parseInt(amount.replace(/\D/g, ''))) : 0;
                        }
                        if (e.keyCode === 38)
                            newamount_1 = e.shiftKey ? newamount_1 + 10 : newamount_1 + 1;
                        if (e.keyCode === 40)
                            newamount_1 = e.shiftKey ? newamount_1 - 10 : newamount_1 - 1;
                        var max = parseInt($(this).attr('data-max')) || 999, min = parseInt($(this).attr('data-min')) || 0;
                        if ($(this).data('debounce'))
                            clearTimeout($(this).data('debounce'));
                        if (!$(this).val())
                            return false;
                        if (newamount_1 < min) {
                            newamount_1 = min;
                            var debounce = setTimeout(function () {
                                methods.setAmount.call($entry_1, $wrapper, newamount_1);
                            }, 500);
                            $(this).data('debounce', debounce);
                            return false;
                        }
                        if (newamount_1 > max)
                            newamount_1 = max;
                        methods.setAmount.call($entry_1, $wrapper, newamount_1);
                    }
                    if (e.type === 'keydown' && (e.keyCode === 38 || e.keyCode === 40))
                        e.preventDefault();
                }
                $input
                    .on('click', function () {
                    this.select();
                })
                    .on('keyup keydown', function (e) {
                    keyupCallback.call(this, e);
                })
                    .on('blur', function () {
                    if (!$(this).val())
                        methods.setAmount.call($(this).closest($data.child), $wrapper, $(this).attr('data-min'));
                });
                $ins.click(function () {
                    var $entry = $(this).closest($data.child), amount = $(this)
                        .parent()
                        .find('input')
                        .val() || 0, newamount = $(this).is('.plus') ? parseInt(amount) + 1 : parseInt(amount) - 1, min = $(this)
                        .parent()
                        .find('input')
                        .attr('data-min') || 0;
                    if (newamount < min)
                        return false;
                    methods.setAmount.call($entry, $wrapper, newamount);
                });
            },
            setAmount: function () {
                var $entry = arguments[2] || this, $entrydata = $entry.data('amountcontrol') || $entry.attr('data-amountcontrol'), $wrapper = arguments[0], newamount = arguments[1], $data = $wrapper.data('amountControl'), $input = $entry.find($data.control).find('input');
                if (newamount <= parseInt($input.attr('data-min'))) {
                    $entry
                        .find($data.control)
                        .find('.minus')
                        .addClass('disabled');
                }
                else if (newamount >= parseInt($input.attr('data-max'))) {
                    $entry
                        .find($data.control)
                        .find('.plus')
                        .addClass('disabled');
                }
                else if (newamount > parseInt($input.attr('data-min')) || newamount < parseInt($input.attr('data-max'))) {
                    $entry
                        .find($data.control)
                        .find('.minus')
                        .removeClass('disabled');
                    $entry
                        .find($data.control)
                        .find('.plus')
                        .removeClass('disabled');
                }
                if (newamount < parseInt($input.attr('data-min')) || newamount > parseInt($input.attr('data-max'))) {
                    (app.callback || $.noop)('amountControlLimitExceeded', {
                        wrapper: $wrapper,
                        input: $input,
                        amount: newamount
                    });
                    return false;
                }
                $input.val(newamount);
                $entrydata.amount = newamount;
                $entrydata.total = $entrydata.amount * $entrydata.price;
                if ($entrydata.price.match(/\./)) {
                    $entrydata.total = $entrydata.total.toFixed(2);
                }
                $entry.data('amountcontrol', $entrydata);
                if (typeof $data.callback_set_amount !== 'undefined') {
                    $data.callback_set_amount({
                        entry: $entry,
                        input: $input
                    });
                }
                methods.updateAmount.call($wrapper);
            },
            updateAmount: function () {
                var $wrapper = this, $data = $wrapper.data('amountControl'), callbackFlag = arguments[0];
                var all_total_amount = 0, all_total_price = 0, all_total_entries = 0;
                if (typeof $data.callback_before_update !== 'undefined') {
                    $data.callback_before_update({
                        total: all_total_amount,
                        entries: all_total_entries
                    });
                }
                $wrapper.find($data.child).each(function (i) {
                    var $entry = $(this), $entrydata = $(this).data('amountcontrol');
                    if (typeof $entrydata === 'undefined')
                        throw 'No data in child entry: ' + (i + 1);
                    if ($data.unit_state_container) {
                        if (!parseInt($entrydata.amount)) {
                            $entry.find($data.unit_state_container).hide();
                        }
                        else {
                            $entry.find($data.unit_state_container).show();
                        }
                    }
                    $entry
                        .find($data.control)
                        .find('input')
                        .val($entrydata.amount);
                    if ($data.unit_amount) {
                        $entry.find($data.unit_amount).html($entrydata.amount);
                    }
                    var itemPrice = $entrydata.price * $entrydata.amount;
                    if (Math.round(itemPrice) != itemPrice) {
                        itemPrice = itemPrice.toFixed(2);
                    }
                    $entry.find($data.unit_total).html(formatNumberWithSpaces(itemPrice));
                    if ($data.unit_total_postfix)
                        $entry.find($data.unit_total).html($entry.find($data.unit_total).html() + ' ' + $data.unit_total_postfix);
                    all_total_amount += parseInt($entrydata.amount);
                    all_total_price += $entrydata.amount * $entrydata.price;
                    all_total_entries = $wrapper.find($data.child).length;
                });
                if (Math.round(all_total_price) != all_total_price) {
                    all_total_price = all_total_price.toFixed(2);
                }
                $($data.all_total_amount).html(all_total_amount);
                $($data.all_total_entries).html(all_total_entries);
                $($data.all_total_price).html(formatNumberWithSpaces(all_total_price));
                if ($data.all_total_price_postfix)
                    $($data.all_total_price).html($($data.all_total_price).html() + ' ' + $data.all_total_price_postfix);
                if ($data.unitname) {
                    $($data.all_total_middle).html(methods.sklonyator({
                        amount: $($data.all_total_entries).length ? all_total_entries : all_total_amount,
                        text: $data.unitname
                    }));
                    if (all_total_amount == 0) {
                        $($data.all_total).hide();
                    }
                    else {
                        $($data.all_total).show();
                    }
                }
                if (!callbackFlag) {
                    if (typeof $data.callback_total_update !== 'undefined') {
                        $data.callback_total_update({
                            total: all_total_amount,
                            price: formatNumberWithSpaces(all_total_price),
                            middle: methods.sklonyator({
                                amount: $($data.all_total_entries).length ? all_total_entries : all_total_amount,
                                text: $data.unitname
                            }),
                            entries: all_total_entries
                        });
                    }
                    if (typeof $data.callback_after_update !== 'undefined') {
                        $data.callback_after_update({
                            total: all_total_amount,
                            entries: all_total_entries
                        });
                    }
                }
                else {
                    if (typeof $data.callback_after_init !== 'undefined') {
                        $data.callback_after_init({
                            total: all_total_amount,
                            price: formatNumberWithSpaces(all_total_price),
                            middle: methods.sklonyator({
                                amount: $($data.all_total_entries).length ? all_total_entries : all_total_amount,
                                text: $data.unitname
                            }),
                            entries: all_total_entries
                        });
                    }
                }
                function formatNumberWithSpaces(num) {
                    if (!num)
                        return '0';
                    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                }
            },
            sklonyator: function () {
                var $data = arguments[0], skloneniya = ['', 'а', 'ов'], value = '';
                if (typeof $data === 'undefined' || typeof $data.amount === 'undefined' || typeof $data.text === 'undefined')
                    return '';
                var lastDigit = Math.floor(($data.amount / Math.pow(10, 0)) % 10);
                if (lastDigit == 0) {
                    value = $data.text + skloneniya[2];
                }
                else if (lastDigit == 1 && ($data.amount > 20 || $data.amount < 10)) {
                    value = $data.text;
                }
                else if (lastDigit >= 2 && lastDigit <= 4 && ($data.amount > 20 || $data.amount < 10)) {
                    value = $data.text + skloneniya[1];
                }
                else if ($data.amount > 10 && $data.amount <= 20) {
                    value = $data.text + skloneniya[2];
                }
                else {
                    value = $data.text + skloneniya[2];
                }
                return value;
            }
        };
        $.fn.amountControl = function (method) {
            if (methods[method]) {
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            }
            else if (typeof method === 'object' || !method) {
                return methods.init.apply(this, arguments);
            }
            else {
                $.error('Method ' + method + ' does not exist on jQuery.amountControl');
            }
        };
    }
};
